import React, { useState } from "react";
import BrandedLoading from "../../common/BrandedLoading";
import EmptyMessage from "../../common/EmptyMessage";
import { useHistory } from "react-router-dom";

import ArchiveCard from "./ArchiveCard";
import { Table, TableBody, TableHead, Typography, TableRow, Pagination, Box, IconButton } from "@mui/material";
import { NameTableCell, MessageTableCell, DateTableCell, StatusTableCell } from "./tableCells";
import useEvents from "../hooks/useEvents";
import {ArrowBack} from '@mui/icons-material';



const Archive = () => {
    const { events, isLoading } = useEvents("email");
    const [page, setPage] = useState(0);
    const rowsPerPage = 10;
    const history = useHistory();
    const archivedEvents = events.filter(event => event.isArchived === true);

    const handleChangePage = (event, newPage) => setPage(newPage - 1);

  const paginatedEvents = archivedEvents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <div>
            <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Box display="flex" alignItems="center">
                    <IconButton
                        color="primary"
                        onClick={() => history.push("/messaging")}
                        aria-label="back to messaging"
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" style={{ marginLeft: '10px' }}>
                        Email Archive
                    </Typography>
                </Box>
            </Box>
            {isLoading ? (
                <BrandedLoading />
            ) : archivedEvents.length === 0 ? (
                <EmptyMessage message={`No archived emails to show.`} />
            ) : (
                <div style={{ maxHeight: "100vh", overflowY: "auto" }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <NameTableCell>Name</NameTableCell>
                                <MessageTableCell>Message</MessageTableCell>
                                <DateTableCell>Date</DateTableCell>
                                <StatusTableCell>Status</StatusTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedEvents.map((event) => (
                                <ArchiveCard key={event._id} event={event} />
                            ))}
                        </TableBody>
                    </Table>
                    <div style={{ display: "flex", justifyContent: "center", margin: "16px" }}>
                        <Pagination count={Math.ceil(archivedEvents.length / rowsPerPage)} page={page + 1} onChange={handleChangePage} color="primary" />
                    </div>
                </div>
            )}
        </>
        </div>
    );
};

export default Archive;
